// Os dois produtos do Flow.Sight. Cada um tem sua propria copia dos charts
// (`components/FlowSight/fxndf` e `components/FlowSight/fxspot`) e, sobretudo,
// seu proprio LAYOUT DE RELATORIO - o CSV de NDF e o de spot nao compartilham
// nem os nomes das colunas nem a nocao de prazo. Ver `flowSightReportLayout.js`.

export const NDF = 'NDF'
export const SPOT = 'SPOT'

export const FLOW_SIGHT_PRODUCTS = [
  {
    product: NDF,
    name: 'FX NDF',
    slug: 'ndf',
    icon: 'mdi-calendar-clock-outline',
    descKey: 'flowSightEntrance.ndf.desc',
    hintKey: 'flowSightEntrance.ndf.hint',
  },
  {
    product: SPOT,
    name: 'FX Spot',
    slug: 'spot',
    icon: 'mdi-flash-outline',
    descKey: 'flowSightEntrance.spot.desc',
    hintKey: 'flowSightEntrance.spot.hint',
  },
]

const bySlug = new Map(FLOW_SIGHT_PRODUCTS.map((p) => [p.slug, p.product]))
const byProduct = new Map(FLOW_SIGHT_PRODUCTS.map((p) => [p.product, p]))

export const isFlowSightProduct = (value) => byProduct.has(value)

export const slugOf = (product) => (byProduct.get(product) || FLOW_SIGHT_PRODUCTS[0]).slug

// Primeira pagina de um produto. Ponto unico: a entrada, o menu lateral e o
// redirect da rota derivam daqui em vez de repetir a string.
export const flowSightHome = (product) => `/flowsight/${slugOf(product)}/overview`

// `/flowsight/spot/conversion` -> 'SPOT'. Devolve null fora da subarvore de um
// produto (a propria tela de entrada, por exemplo).
export function productFromPath (path) {
  const slug = String(path || '').split('/')[2]
  return bySlug.get(slug) || null
}
